import { StateToken } from '@ngxs/store';
import { CurrentDataModel } from './current-data.state';

/**
 * Token referencing CurrentDataState. Use this in selectSnapshot/select calls
 * to avoid TypedSelector<unknown> errors introduced in NGXS v18.
 */
export const CURRENT_DATA_STATE_TOKEN = new StateToken<CurrentDataModel>('currentData');
